import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
  const navigate = useNavigate();

  return (
    <header
      className="fixed left-0 top-0 z-50 flex h-14 w-full items-center justify-between bg-white px-6"
      role="banner"
    >
      <Link
        to="/users"
        className="cursor-pointer"
        aria-label="Go to user list page"
      >
        <img
          src="/img/logo_b2b.svg"
          alt="Kmonstar Admin Logo"
          className="h-5"
        />
      </Link>
    </header>
  );
};

export default Header;
